import React from 'react'
import './SectionContainer.css'

const SectionContainer = ({children,whiteBG}) => {
    return (
        <div className={`${whiteBG?'info':'info non-white-bg'}`}>
            <div className='wrapper'>
                {children}
            </div>
        </div>
    )
}

export default SectionContainer
